import React from "react";
import Grid from "@material-ui/core/Grid";
import Button from "./Button";
import WoodenInput from "./WoodenInput";
import WhiteButton from "./WhiteButton";
import BlackButton from "./BlackButton";
import PicoLoader from "../../Common/PicoLoader";
import Exit from "../../../../assets/images/exit.png";

import axios from "axios";
import {freeGiftRedeem, freeRefCode} from "../../../../Utility/Url";

class Invitation extends React.Component{
    constructor() {
        super();
        this.inputRef = React.createRef()
        this.state= {
            picoSmallLoader:false
        }
    }
    handleClick=async ()=>{
        this.setState({
            picoSmallLoader:true
        })
        const code=this.inputRef.current.state.input
        if (code===undefined){
            const obj=
                {
                    dialog:{
                        id: 0,
                        icon:Exit,
                        title: "خطا",
                        message: "لطفا کد معرف را به شکل صحیح 6 رقمی وارد کنید",
                        ok: null,
                        cancel: {
                            text: "بستن",
                            action: "#cancel"
                        },
                        style: {
                            type: "danger",
                            borderColor: "#7b241c",
                            background: "#c0392b",
                            contentColor: "#d98880",
                            contentTextColor: "#ffffff"
                        }
                    }
                }
            this.props.callBack(obj)
            this.setState({
                picoSmallLoader:false
            })
        }
        else {
            await axios.post(freeRefCode,{
                code:code
            })
                .then(res => {
                    this.setState({
                        picoSmallLoader:false
                    })
                    const {data}=res
                    this.props.callBack(data)
                }).catch(error=>{
                        console.log(error.toString())
                    }
                )
        }
    }
    share=async ()=>{
        const url = 'http://play.google.com/store/apps/details?id=com.diacoipj.picopool&hl=fa';
        let code = document.querySelector('#invitation-text').innerHTML
        const text = `${code}  این کد معرف رو بزن تا 1سکه نقره جایزه بگیریم بازی جذاب پیکوپول رو از لینک زیر نصب کن، هر روز جوایز میلیونی دارند. میتونی اینجا کلی پول برنده شی `
        try {
            await navigator
                .share({
                    url,
                    text
                })
        } catch (err) {
            alert('مرورگر خود را بروز کنید');
        }    }
    render() {
        const {
            whiteButtonBackgroundColor,
            whiteButtonText,
            introductionButtonText,
            introductionButtonColor,
            introductionButtonBackgroundColor,
            buttonText,
            buttonTextColor,
            blackButtonText,
            blackButtonIcon,
            blackButtonBackgroundColor,
            blackButtonTextColor,
            buttonColor,
            firstLayerColor,
            text,
            secondLayerColor,
            thirdLayerColor,
            topLayerBackgroundColor
        }
        =this.props.data

        const button={
            text:buttonText,
            backgroundColor:buttonColor,
            bottomFontSize:'15px',
            buttonTextColor:buttonTextColor
        }
        const introductionButton={
            text:introductionButtonText,
            backgroundColor:introductionButtonBackgroundColor,
            bottomFontSize:'15px',
            buttonTextColor:introductionButtonColor
        }
        const woodenInput={
            backgroundColor:'lightblue',
            layerRadius:'15px',
            inputTextSize:'30px',
            inputMaxLength:'6',
        }
        const whiteButton={
            backgroundColor:whiteButtonBackgroundColor,
            text:whiteButtonText
        }
        const blackButton={
            backgroundColor:blackButtonBackgroundColor,
            blackButtonTextColor:blackButtonTextColor,
            text:blackButtonText,
            textColor:blackButtonTextColor,
            icon:blackButtonIcon
        }
        const{picoSmallLoader}=this.state
        return(
            <Grid justify={'center'} className='item-holder' xs={12} sm={12}  item container
                  style={{backgroundColor:firstLayerColor}}>
                <Grid alignItems={"center"} justify={"center"} xs={12} sm={12} item container className='item-holder-first-layer'
                      style={{backgroundColor:secondLayerColor}}>
                    <Grid sm={12} xs={12} alignItems={"flex-start"} justify={"center"} item container
                          className='item-holder-first-layer-second-layer invitation-top-overlay'
                          style={{backgroundColor:topLayerBackgroundColor,marginBottom:'10px'}}>
                        <Grid justify={"space-between"} item container style={{backgroundColor:'rgba(0,0,0,0.1)',width:'100%',padding:'0 10px'}}>
                            <Grid container alignItems={"center"} justify={"center"}
                                  style={{height:'50px'}} sm={3} xs={3}
                            >
                                <BlackButton data={blackButton}/>
                            </Grid>
                            <Grid sm={5} xs={5}>
                                <p>
                                    {text}
                                </p>
                            </Grid>
                        </Grid>
                        <Grid  justify={"space-around"} alignItems={"center"} item container>
                            <Grid alignItems={"center"} style={{position:'relative',height:'50px'}}
                                  item sm={4} xs={4} container
                                  className={'clickable'}
                                  onClick={()=>{
                                      this.share()
                                  }}
                            >
                                <Button data={introductionButton}/>
                            </Grid>
                            <Grid item sm={4} xs={4} container style={{height:'50px'}} alignItems={"center"}>
                                <WhiteButton data={whiteButton}/>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid sm={12} xs={12} justify={"center"} alignItems={"center"} item container
                          className='item-holder-first-layer-second-layer invitation-bottom-overlay'
                          style={{backgroundColor:thirdLayerColor}}>
                        <Grid container sm={11} xs={11} alignItems={"center"} justify={"space-around"} item style={{width:'100%'}}>
                            <Grid sm={3} alignItems={"center"} xs={3} style={{height:'60px'}} item container>
                                {
                                    !picoSmallLoader &&
                                    <Grid sm={12} style={{position:'relative',height:'60px'}} xs={12} alignItems={"center"}
                                          onClick={() => {this.handleClick() }} className='clickable'  justify={"center"} container>
                                        <Button data={button}/>
                                    </Grid>
                                }
                                {
                                    picoSmallLoader &&
                                    <Grid sm={5} xs={5} container alignItems={"center"} direction={"row-reverse"} justify={"center"}
                                          style={{position:'relative',height:'50px'}}
                                    >
                                        <Grid item container justify={"center"} alignItems={"center"} style={{position:'absolute'}}>
                                            <PicoLoader/>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                            <Grid sm={7} xs={7} item>
                                <WoodenInput input={this.handleClick} data={woodenInput} ref={this.inputRef}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }

}
export  default Invitation